import { render, staticRenderFns } from "./FriendMsg.vue?vue&type=template&id=a8bb9fa0&scoped=true"
import script from "./FriendMsg.vue?vue&type=script&lang=js"
export * from "./FriendMsg.vue?vue&type=script&lang=js"
import style0 from "./FriendMsg.vue?vue&type=style&index=0&id=a8bb9fa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bb9fa0",
  null
  
)

export default component.exports